var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGerenricContentBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 413,
    height: 577,
    viewBox: "0 0 413 577",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 288.383,
    y: 0.773438,
    width: 406.749,
    height: 406.749,
    transform: "rotate(45 288.383 0.773438)",
    fill: "#00252D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85.0859,
    y: 85.0117,
    width: 406.749,
    height: 406.749,
    fill: "#FF5F45"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 287.871,
    y: 115.953,
    width: 243.979,
    height: 243.979,
    transform: "rotate(45 287.871 115.953)",
    fill: "#006A99"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 149.844,
    y: 149.766,
    width: 277.237,
    height: 277.237,
    fill: "#25307F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 206.504,
    y: 206.43,
    width: 163.914,
    height: 163.914,
    fill: "#00252D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 288.008,
    y: 192.719,
    width: 135.295,
    height: 135.295,
    transform: "rotate(45 288.008 192.719)",
    fill: "#FFA540"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGerenricContentBg);
export default __webpack_public_path__ + "static/media/gerenric_content_bg.39e143a6a055c87c7f4087d323dcc2e2.svg";
export { ForwardRef as ReactComponent };